import SettingsIcon from '@mui/icons-material/Settings'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { ROLE_TYPES } from 'src/consumer/constants'
import { appVersion, platformWeb } from 'src/consumer/services'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import ClinicHeader from '../ClinicHeader'
import { HeaderGreeting } from '../ClinicHeader/ClinicHeaderStyles'
import { HomePageItem } from '../ClinicHomePage/ClinicHomepageStyles'
import { CADeviceUseFixingComponent } from '../ClinicHomePage/components/CADeviceUseFixingComponent'
import {
  AvailabilityPageContainer,
  ClinicTabButtonsContainer,
} from '../ClinicManageBookingsPage/ClinicManageBookingsPageStyles'

export default function ClinicCounterScreen() {
  const { clinicId } = useParams()
  const navigate = useNavigate()
  const { chosenRoleFlow, assistantData } = useContext(ClinicDataContext)

  const [mentorsLoading, setMentorsLoading] = useState(false)
  const [managersProfileData, setManagersProfileData] = useState([])

  const [CAFlowDialogOpen, setsCAFlowDialogOpen] = useState(false)

  const thisClinic = assistantData?.associatedClinicsData?.find((item) => item?.id === clinicId)
  const assistantProfileInThisClinic = assistantData?.clinicAssistantProfileData?.find(
    (item) => item?.clinicId === clinicId,
  )

  async function getAndSetManagersProfileData() {
    setMentorsLoading(true)
    const assistantProfileInThisClinic = assistantData?.clinicAssistantProfileData?.find(
      (item) => item?.clinicId === clinicId,
    )
    if (Array.isArray(assistantProfileInThisClinic?.supportRoles)) {
      await assistantProfileInThisClinic?.supportRoles?.forEach(async (supportRole) => {
        const response = await getCPDataWithoutParams(
          `/api/secure/clinic-assistant/service-provider?id=${
            supportRole?.managerId
          }&slug=&zoneOffset=${encodeURIComponent(
            getTimezoneOffset(),
          )}&appVersion=${appVersion}&platformType=${platformWeb}`,
        )
        if (response.status === 200) {
          setManagersProfileData((prev) => [...prev, response?.data])
        }
      })
    }
    setMentorsLoading(false)
  }

  useEffect(() => {
    getAndSetManagersProfileData()
  }, [assistantData])

  return (
    <AvailabilityPageContainer>
      <ClinicHeader
        component={
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <GenericHeaderBackButton
              clickfunction={() => window.history.back()}
              styles={{ margin: '20px' }}
            />
            <HeaderGreeting main>
              {`Counter Screen:  ${thisClinic?.title || ''}` || 'Counter Screen for'}
            </HeaderGreeting>
          </div>
        }
      />
      {mentorsLoading ? (
        <Spinner animation="border" variant="dark" size="md" />
      ) : (
        <div>
          {/* Only for Assistant */}
          {chosenRoleFlow === ROLE_TYPES.roleClinicAssistant && (
            <div className="w-100 d-flex" style={{ justifyContent: 'right', paddingRight: '16px' }}>
              <SettingsIcon
                onClick={() => setsCAFlowDialogOpen(true)}
                style={{ cursor: 'pointer' }}
              />
              <div style={{ position: 'absolute', top: '4px', right: '8px' }}>
                <CADeviceUseFixingComponent
                  CAFlowDialogOpen={CAFlowDialogOpen}
                  setsCAFlowDialogOpen={setsCAFlowDialogOpen}
                />
              </div>
            </div>
          )}
          <ClinicTabButtonsContainer>
            {assistantProfileInThisClinic?.supportRoles?.map((supportRole, supportRoleIndex) => (
              <HomePageItem
                key={supportRoleIndex}
                onClick={() => navigate(`${supportRole?.managerId}`)}
              >
                {
                  managersProfileData?.find((item) => item?.id === supportRole?.managerId)
                    ?.firstName
                }
              </HomePageItem>
            ))}
          </ClinicTabButtonsContainer>
        </div>
      )}
    </AvailabilityPageContainer>
  )
}
